<template>
  <BaseDialog
    ref="baseDialog"
    modal-id="removeGroupDialog"
    :title="$t('removeGroup.title', { groupName })"
    :loading="loading"
    :confirm-text="$t('removeGroup.confirm')"
    confirm-variant="warning"
    @confirm="handleRemove"
  >
    <template #body>
      <p>
        {{ $t('removeGroup.confirmText', { groupName }) }}
      </p>
      <p class="text-warning">
        {{ $t('removeGroup.note') }}
      </p>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, defineProps, defineExpose, defineEmits } from 'vue';
import BaseDialog from '@/components/common/BaseDialog.vue';

 defineProps({
  groupName: String
});

const emit = defineEmits(['remove']);
const baseDialog = ref(null);
const loading = ref(false);

const openDialog = () => {
  loading.value = false;
  baseDialog.value.openDialog();
};

const closeDialog = () => {
  baseDialog.value.closeDialog();
};

const handleRemove = async () => {
  loading.value = true;
  try {
    emit('remove');
    closeDialog();
  } finally {
    loading.value = false;
  }
};

defineExpose({ openDialog, closeDialog });
</script>
